module.exports = __webpack_public_path__ + "static/media/th.1173b91f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/th.svg
// module id = 104
// module chunks = 0